<button type="button"
        class="region-chip"
        [matMenuTriggerFor]="regionMenu"
        [attr.aria-label]="'main.labels.selectYourRegion' | translate">
    <img class="region-chip-icon" src="assets/images/icon/region-pin.png" alt="">
    <span class="region-chip-label">{{ shortLabelKey(currentRegion) | translate }}</span>
</button>

<!-- Panel stili global: styles.scss `.region-sheet` (mobilde alt sayfa gibi açılır) -->
<mat-menu #regionMenu="matMenu" class="region-sheet" xPosition="before">
    <div class="region-sheet-title">{{ 'main.labels.selectYourRegion' | translate }}</div>
    <button mat-menu-item
            *ngFor="let region of regions"
            class="region-sheet-item"
            [class.selected]="isCurrent(region)"
            (click)="changeRegion(region)">
        <span class="region-sheet-item-label">{{ shortLabelKey(region) | translate }}</span>
        <mat-icon *ngIf="isCurrent(region)" class="region-sheet-check">check</mat-icon>
    </button>
</mat-menu>
